import { GetCompanyValuesResponse } from '@momentum/types';
import { apiClient } from './api';

export const valuesService = {
  async getAllCompanyValues(
    companyId: string
  ): Promise<GetCompanyValuesResponse> {
    return (await apiClient.get(`/companies/${companyId}/values`)).data;
  },
};
